module.exports = __webpack_public_path__ + "static/img/listar_noticia_page.2b540bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listar_noticia_page.jpg
// module id = xsI7
// module chunks = 1